import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { toast, Toaster } from "sonner";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Plus, Trash2, UserPlus, School } from "lucide-react";

export default function AssignmentGuru() {
  const [items, setItems] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [schools, setSchools] = useState([]);
  const [meta, setMeta] = useState({ academic_years: [], active_year: "" });
  const [dialog, setDialog] = useState(false);
  const [form, setForm] = useState({ teacher_id: "", school_id: "", academic_year: "" });

  const load = () => api.get("/assignments").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    api.get("/teachers").then((r) => setTeachers(r.data.filter((t) => !t.is_staff)));
    api.get("/my/schools").then((r) => setSchools(r.data));
    api.get("/academic/meta").then((r) => setMeta(r.data));
  }, []);

  const openNew = () => { setForm({ teacher_id: "", school_id: "", academic_year: meta.active_year || "" }); setDialog(true); };
  const save = async () => {
    if (!form.teacher_id || !form.school_id || !form.academic_year) { toast.error("Lengkapi semua pilihan"); return; }
    try { await api.post("/assignments", form); toast.success("Penugasan ditambahkan"); setDialog(false); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };
  const remove = async (a) => {
    if (!window.confirm(`Hapus penugasan ${a.teacher_name} di ${a.school_name}?`)) return;
    try { await api.delete(`/assignments/${a.id}`); toast.success("Penugasan dihapus"); load(); }
    catch (e) { toast.error(e.response?.data?.detail || "Gagal"); }
  };

  const bySchool = {};
  items.forEach((a) => { (bySchool[a.school_name] = bySchool[a.school_name] || []).push(a); });

  return (
    <div className="space-y-5" data-testid="assignments-page">
      <Toaster position="top-center" richColors />
      <div className="flex items-center justify-between">
        <div>
          <h2 className="font-nunito font-extrabold text-2xl text-gtsnavy">Assignment Guru</h2>
          <p className="text-sm text-muted-foreground">Penugasan guru ke sekolah per tahun pelajaran</p>
        </div>
        <Button onClick={openNew} className="rounded-full bg-gradient-to-r from-gtsorange to-gtsorange-light text-white gap-1" data-testid="add-assignment-btn"><Plus className="w-4 h-4" /> Tambah</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(bySchool).map(([school, list]) => (
          <Card key={school} className="rounded-2xl border-none shadow-sm p-5 bg-white" data-testid={`assignment-school-${school.replace(/\s+/g, "-")}`}>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-9 h-9 rounded-xl bg-gtsnavy/10 flex items-center justify-center"><School className="w-4 h-4 text-gtsnavy" /></div>
              <p className="font-nunito font-bold text-gtsnavy">{school}</p>
            </div>
            <div className="space-y-2">
              {list.map((a) => (
                <div key={a.id} className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2" data-testid={`assignment-${a.id}`}>
                  <div className="flex items-center gap-2 text-sm"><UserPlus className="w-4 h-4 text-gtsorange" /> {a.teacher_name}<Badge className="rounded-full bg-white text-xs text-muted-foreground ml-1">{a.academic_year}</Badge></div>
                  <Button size="sm" variant="ghost" onClick={() => remove(a)} className="text-rose-600 h-7 w-7 p-0" data-testid={`delete-assignment-${a.id}`}><Trash2 className="w-4 h-4" /></Button>
                </div>
              ))}
            </div>
          </Card>
        ))}
      </div>

      <Dialog open={dialog} onOpenChange={setDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Tambah Penugasan</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <Label>Guru</Label>
              <Select value={form.teacher_id} onValueChange={(v) => setForm({ ...form, teacher_id: v })}>
                <SelectTrigger className="rounded-xl mt-1" data-testid="assign-teacher"><SelectValue placeholder="Pilih guru" /></SelectTrigger>
                <SelectContent>{teachers.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>
              <Label>Sekolah</Label>
              <Select value={form.school_id} onValueChange={(v) => setForm({ ...form, school_id: v })}>
                <SelectTrigger className="rounded-xl mt-1" data-testid="assign-school"><SelectValue placeholder="Pilih sekolah" /></SelectTrigger>
                <SelectContent>{schools.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>
              <Label>Tahun Pelajaran</Label>
              <Select value={form.academic_year} onValueChange={(v) => setForm({ ...form, academic_year: v })}>
                <SelectTrigger className="rounded-xl mt-1" data-testid="assign-year"><SelectValue placeholder="Pilih" /></SelectTrigger>
                <SelectContent>{(meta.academic_years || []).map((y) => <SelectItem key={y.year} value={y.year}>{y.year}</SelectItem>)}</SelectContent>
              </Select>
            </div>
          </div>
          <DialogFooter><Button onClick={save} className="rounded-full bg-gtsnavy text-white" data-testid="save-assignment-btn">Simpan</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
